// extracted by mini-css-extract-plugin
module.exports = {"editor":"RichTextEditor_editor__1C6wE","editorToolbar":"RichTextEditor_editorToolbar__3InXS","editorWrapper":"RichTextEditor_editorWrapper__1q-3H"};